export const REMOVE_ROLE = 'REMOVE_ROLE';
export const LOAD_ROLES = 'LOAD_ROLES';
export const LOAD_ROLE = 'LOAD_ROLE';
export const ADD_ROLE = 'ADD_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';


export function removeRole(data) {
  return {
    type: REMOVE_ROLE,
    payload: data
  }
}
export function loadRoles(data) {
  return {
    type: LOAD_ROLES,
    payload: data
  }
}
export function loadRole(data) {
  return {
    type: LOAD_ROLE,
    payload: data
  }
}
export function addRole(data) {
  return {
    type: ADD_ROLE,
    payload: data
  }
}
export function updateRole(data) {
  return {
    type: UPDATE_ROLE,
    payload: data
  }
}


// WEBPACK FOOTER //
// ./src/actions/roles/index.js